import { DateTime } from 'luxon';
import { DATE_FORMATS } from './constants';

export const CAR_PICKUP_MINIMUM_HOURS = 72;

export function getCarPickupMinimumDateTime(
	now: DateTime = DateTime.now()
): DateTime {
	return now.plus({ hours: CAR_PICKUP_MINIMUM_HOURS });
}

export function isCarPickupDateTimeAllowed(
	pickUpDateTime: DateTime,
	now: DateTime = DateTime.now()
): boolean {
	return (
		pickUpDateTime.isValid && pickUpDateTime >= getCarPickupMinimumDateTime(now)
	);
}

export function formatMinimalDateRange(from: DateTime, to: DateTime): string {
	if (!from.isValid || !to.isValid) {
		return '';
	}

	const sameMonth = to.month === from.month;
	const sameYear = to.year === from.year;

	const startFormatted = from.toFormat(
		sameMonth ? 'dd' : sameYear ? 'dd MMM' : DATE_FORMATS.DISPLAY_DATE
	);
	const endFormatted = to.toFormat(`${DATE_FORMATS.DISPLAY_DATE}`);

	return `${startFormatted} - ${endFormatted}`;
}
